export const DIAMOND = 'DIAMOND';
export const ELITE = 'ELITE';
export const GOLD = 'GOLD';
export const NONE = 'NONE';
export const PLATINUM = 'PLATINUM';